(() => {
  const componentSelector = '.product-quantity__quantity'
  const inputSelector = `${componentSelector} [data-quantity-input]`

  const getInput = (element) => element.closest(componentSelector)?.querySelector('[data-quantity-input]')

  const getLimits = (input) => ({
    min: Number(input.min || 0),
    max: Number(input.max || input.closest(componentSelector)?.dataset.stock || 9999),
  })

  const updateButtons = (input) => {
    const component = input.closest(componentSelector)
    const { min, max } = getLimits(input)
    const value = input.value === '' ? min : Number(input.value)

    component.querySelectorAll('quantity-btn[data-action]').forEach((wrapper) => {
      const limit = wrapper.dataset.action === 'minus' ? min : max
      const disabled = wrapper.dataset.action === 'minus' ? value <= limit : value >= limit

      wrapper.toggleAttribute('disabled', disabled)
      wrapper.querySelector('button')?.toggleAttribute('disabled', disabled)
    })
  }

  const commitInput = (input) => {
    const { min, max } = getLimits(input)
    const value = Number(input.value)

    if (input.value === '' || Number.isNaN(value) || value < min) {
      input.value = min
    } else if (value > max) {
      input.value = max
    }

    updateButtons(input)
  }

  const initialize = (root = document) => {
    if (root.matches?.(inputSelector)) updateButtons(root)
    root.querySelectorAll?.(inputSelector).forEach(updateButtons)
  }

  // The theme's quantity component clamps on every keystroke. Product quantities
  // are instead clamped when editing is committed (change, blur, or Enter).
  document.addEventListener(
    'input',
    (event) => {
      if (!event.target.matches(inputSelector)) return

      event.stopImmediatePropagation()
      updateButtons(event.target)
    },
    true,
  )

  document.addEventListener('change', (event) => {
    if (event.target.matches(inputSelector)) commitInput(event.target)
  }, true)

  document.addEventListener('blur', (event) => {
    if (event.target.matches(inputSelector)) commitInput(event.target)
  }, true)

  document.addEventListener('click', (event) => {
    const wrapper = event.target.closest(`${componentSelector} quantity-btn[data-action]`)
    if (wrapper?.hasAttribute('disabled')) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
  }, true)

  document.addEventListener('click', (event) => {
    const wrapper = event.target.closest(`${componentSelector} quantity-btn[data-action]`)
    const input = wrapper && getInput(wrapper)
    if (input) updateButtons(input)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return

    const wrapper = event.target.closest(`${componentSelector} quantity-btn[data-action]`)
    if (wrapper?.hasAttribute('disabled')) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
  }, true)

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return

    const wrapper = event.target.closest(`${componentSelector} quantity-btn[data-action]`)
    const input = wrapper && getInput(wrapper)
    if (input) updateButtons(input)
  })

  document.addEventListener('DOMContentLoaded', () => initialize())

  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initialize(node)
      })
    })
  }).observe(document.documentElement, { childList: true, subtree: true })
})()
